let lenis = null;

export const setLenis = (instance) => {
  lenis = instance;
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const RULES_PDF_URL = "#rules-sheet-pdf-placeholder";
export const INSTAGRAM_URL = "https://www.instagram.com/convey.awards/";
export const CONTACT_EMAIL = "jappemedia@gmail.com";
